import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router"
import { useAuthStore } from "../stores/auth"

const routes: RouteRecordRaw[] = [
  { path: "/",               component: () => import("../views/HomeView.vue") },
  { path: "/auth/callback",  component: () => import("../views/AuthCallbackView.vue") },
  { path: "/dashboard",      component: () => import("../views/DashboardView.vue"), meta: { auth: true } },
  { path: "/audit",            component: () => import("../views/AuditView.vue"),     meta: { auth: true, roles: ["mc-admin","mc-management"] } },
  { path: "/m/management",     component: () => import("../views/ManagementView.vue"), meta: { auth: true, roles: ["mc-management","mc-admin"] } },
  { path: "/m/bd",             component: () => import("../views/BdView.vue"),         meta: { auth: true, roles: ["mc-bd","mc-management","mc-admin"] } },
  { path: "/m/pmo",            component: () => import("../views/MissionBoardView.vue"), meta: { auth: true, roles: ["mc-pmo","mc-management","mc-admin"] } },
  { path: "/m/pmo/studies/new",     component: () => import("../views/StudyRegisterView.vue"), meta: { auth: true, roles: ["mc-pmo","mc-management","mc-admin"] } },
  { path: "/m/pmo/studies/:id/edit", component: () => import("../views/StudyEditView.vue"),    meta: { auth: true, roles: ["mc-pmo","mc-management","mc-admin"] } },
  { path: "/m/finance",        component: () => import("../views/FinanceView.vue"),    meta: { auth: true, roles: ["mc-finance","mc-management","mc-admin"] } },
  { path: "/m/ops",            component: () => import("../views/OperationsView.vue"), meta: { auth: true, roles: ["mc-ops","mc-management","mc-admin"] } },
  { path: "/m/loyalty-shares", component: () => import("../views/LoyaltySharesView.vue"), meta: { auth: true, roles: ["mc-shares","mc-finance","mc-management","mc-admin"] } },
  { path: "/m/rbqm-trends",            component: () => import("../views/RbqmTrendsView.vue"), meta: { auth: true } },
  { path: "/m/rbqm-trends/sources",    component: () => import("../views/RbqmSourcesView.vue"), meta: { auth: true, roles: ["mc-admin"] } },
  { path: "/m/admin/audit",    component: () => import("../views/AuditExplorerView.vue"), meta: { auth: true, roles: ["mc-admin","mc-management"] } },
  { path: "/m/admin/settings", component: () => import("../views/AdminSettingsView.vue"), meta: { auth: true, roles: ["mc-admin"] } },
  { path: "/m/:module",        component: () => import("../views/ModulePlaceholder.vue"), meta: { auth: true } },
  { path: "/:pathMatch(.*)*", component: () => import("../views/NotFoundView.vue") },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  if (!to.meta.auth) return true
  const auth = useAuthStore()
  if (!auth.signedIn) {
    await auth.hydrate()
  }
  if (!auth.signedIn) return { path: "/", query: { redirect: to.fullPath } }

  const required = (to.meta.roles as string[] | undefined) ?? []
  if (required.length === 0) return true
  if (!auth.me) await auth.refreshMe()
  const ok = required.some((r) => auth.hasRole(r))
  return ok ? true : { path: "/dashboard", query: { forbidden: required.join(",") } }
})
